<style lang="less" scoped>
  .selector{
    display: inline-block;
    width: 100%;
  }
  .selector /deep/ .ivu-poptip{
    width: 100%;
  }
  .selector /deep/ .ivu-poptip-inner{
    border-radius: 0;
  }
  .selector /deep/ .ivu-poptip-rel{
    width: 100%;
  }
  .selector /deep/ .ivu-poptip-body{
    padding: 0;
  }
  .select-item{
    padding: 5px;
    cursor: pointer;
    &:hover{
      background: #f5f5f5;
      .avatar{
        transform: scale(1.06);
      }
    }
  }
  .select-disabled{
    color: #999;
    background: #f5f5f5;
    cursor: not-allowed;
  }
  .selector-btn{
    position: relative;
    padding-left: 8px;
    padding-right: 8px;
    text-align: left;
    .delete-btn{
      display: none;
    }
  }
  .selector-btn-deletable{
    padding-right: 25px;
    .delete-btn {
      display: inline-block;
      width: auto;
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translate(0, -50%);
      &:hover {
        transform: translate(0, -50%) scale(1.5, 1.5);
      }
    }
  }
  .type-text{
    padding: 4px 6px;
    line-height: 1;
    border: none;
    &:focus{
      box-shadow: none;
    }
  }
  .search-area /deep/ input{
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
  }
  .search-area /deep/ .ivu-input-group-append{
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    background: transparent;
  }
  .select-container{
    margin-top: 5px;
    height: 160px;
    overflow: auto;
  }
  .avatar-wrapper{
    display: inline-block;
    vertical-align: middle;
    width: 60px;
    height: 60px;
    overflow: hidden;
    .avatar{
      width: 100%;
      height: 100%;
      transition: transform .25s ease;
      will-change: transform;
    }
  }
</style>
<template>
  <div
    class="selector"
    :style="{width: long ? '100%' : 'auto'}"
  >
    <Poptip
      v-if="searchable"
      placement="bottom"
      :width="width"
      :transfer="transfer"
      @on-popper-show="poperShow"
    >
      <i-button
        class="selector-btn"
        :class="{'type-text': type === 'text', 'selector-btn-deletable': deletable}"
        :type="type"
        :size="size"
        :long="long"
        :icon="icon"
        :disabled="disabled"
        :loading="initing"
      >
        <slot>
          <span v-if="item.id">{{ item.name }}</span>
          <span
            v-else
            class="color-grey"
          >选择...</span>
        </slot>
        <Poptip
          class="delete-btn"
          title="你确定要删除吗?"
          confirm
          @click.native.stop=""
          @on-ok="delItem"
        >
          <Icon type="md-close" />
        </Poptip>
      </i-button>
      <div
        v-show="!disabled"
        slot="content"
        class="pop-tip-content"
      >
        <i-input
          v-model="search_text"
          class="search-area"
          search
          placeholder="搜索..."
          @on-search="searchItem"
        />
        <div
          v-if="loading"
          class="text-center"
        >
          <Spin fix />
        </div>
        <div class="select-container">
          <div
            v-for="item in items"
            :key="item.id"
            class="select-item"
            :class="{'select-disabled': item.id === value}"
            @click="setItem(item)"
          >
            <slot
              name="item"
              :item="item"
            >
              <span>{{ item.name }}</span>
              <span v-if="isPerson(item)"> - {{ item.id_number }}</span>
            </slot>
          </div>
        </div>
      </div>
    </Poptip>
    <div v-else>
      <span v-if="item.id">{{ item.name }}</span>
      <span
        v-else
        class="color-grey"
      >-</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: Number
      },
      type: {
        type: String
      },
      size: {
        type: String
      },
      icon: {
        type: String
      },
      width: {
        type: [Number, String],
        default: 300
      },
      disabled: {
        type: Boolean,
        default: false
      },
      long: {
        type: Boolean,
        default: true
      },
      transfer: {
        type: Boolean,
        default: false
      },
      deletable: {
        type: Boolean,
        default: false
      },
      searchable: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        search_text: '',
        items: [],
        loading: false,
        initing: false,
        item: {}
      }
    },
    computed: {
      //
    },
    watch: {
      value() {
        this.initItem();
      }
    },
    created() {
      this.initItem();
    },
    mounted() {
      //
    },
    methods: {
      poperShow() {
        if (this.items.length === 0) {
          this.searchItem();
        }
      },
      initItem(retry_count = 0) {
        if (this.item && this.item.id) return;
        if (!this.value) return;
        if (this.initing) return;
        this.initing = true;
        this.$util.ajax.get(this.$util.api.find_payee_company, {
          params: {
            id: this.value
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.item = data.payee_company;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.initing = false;
          // 失败重试
          if (!this.item.id && retry_count < 3) {
            this.initItem(retry_count + 1);
          }
        });
      },
      isPerson(item) {
        return item.company_type === 0;
      },
      searchItem() {
        if (this.loading) return;
        this.loading = true;
        this.$util.ajax.get(this.$util.api.search_supplier, {
          params: {
            search: this.search_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.items = data.payee_companies;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      setItem(item) {
        this.item = item;
        this.$emit('input', item.id);
        this.$emit('on-change', item);
        document.body.click();
      },
      delItem() {
        this.$emit('on-delete');
      },
    }
  }
</script>
